<template>
  <div class="marketing-parallax-image">
    <AppParallaxImage :image="image.src" :alt="blok.image?.alt || ''" :poster="image.poster" />
  </div>
</template>

<script lang="ts" setup>
  const { blok } = defineProps<{
    blok: MarketingParallaxImageBlokStoryblok;
  }>();

  const image = computed(() => {
    return {
      src: blok.image?.filename || '',
      width: getImageDimensionsFromStoryblokSrc(blok.image?.filename || '').width,
      height: getImageDimensionsFromStoryblokSrc(blok.image?.filename || '').height,
      // Only meaningful when `image` holds a video; optional field, so it may be absent
      poster: blok.poster?.filename || '',
    };
  });
</script>
